const showMore = (e: any, classes: string) => {
    if (e.target.closest('.item_more')) {
        e.target.closest('.item_more').classList.toggle(`${classes}`);
    }
}

const renderContent = (column: any, item: any, value: string, classes: any) => {
    return column.id === value ? <div className={classes} key={'' + value}>{column.render(item)}</div> : <></>
}

export { showMore, renderContent }